import { Flex, Span } from '@fareye/ui'
import { startCase } from '@fareye/utils'
import React from 'react'
import { extraInfoForStop } from '../../utility/funcs'
import { MMStopsDetails } from './../../style/styled'
import { FieldValue } from './FieldValue'
import { displayTimeSecondFormat } from './function'
import { useTranslation } from '@fareye/common'
import { valueColor } from '@fareye/configs'

export function StopDetails({ positionStyle, details, hideETA, close }: any) {
  const {
    eta,
    ata,
    etd,
    atd,
    std,
    name,
    sta,
    city,
    state,
    status,
    sequence,
    nodeColor,
    activityType
  } = details || {}
  const extraInfo = extraInfoForStop(details)
  const { t } = useTranslation()
  const isDelivered = nodeColor === 'green' || nodeColor === 'orange'
  return (
    <MMStopsDetails style={{ ...positionStyle }} className="popover">
      <Flex column>
        <Span
          variant="ellipsis h5"
          style={{ marginBottom: 4, fontSize: '12px' }}
        >
          {`S${sequence}: ${city || name}`}
        </Span>
        <Span
          variant="ellipsis secondary"
          style={{ marginBottom: 4, fontSize: '12px' }}
        >
          {name}
        </Span>
        <Flex style={{ marginTop: '4px', marginBottom: '4px' }}>
          {activityType !== 'na' ? (
            <Span
              color="rgba(24,144,255,1)"
              variant="ellipsis secondary"
              style={{ padding: '9px 0px', fontSize: '12px' }}
            >
              {t(startCase(activityType))}
            </Span>
          ) : null}
          <Span
            color={isDelivered ? 'rgba(39,155,78,1)' : 'rgba(238,98,82,1)'}
            style={{
              padding: '9px 12px',
              borderRadius: '4px',
              fontSize: '12px',
              lineHeight: '14px',
              background: isDelivered
                ? 'rgba(39,155,78,0.2)'
                : 'rgba(238,98,82,0.2)'
            }}
          >
            {isDelivered ? 'Delivered' : 'Undelivered'}
          </Span>
        </Flex>
      </Flex>
      <FieldValue
        style={{ marginBottom: 4, fontSize: '12px' }}
        labelStyle={{
          color: valueColor,
          fontWeight: 500
        }}
        label={`${t('Route State')}`}
        value={t(state) || '-'}
      />
      {status ? (
        <FieldValue
          style={{ marginBottom: 15, fontSize: '12px' }}
          labelStyle={{ color: '#000000', fontWeight: 500 }}
          label={`${t('Status')}: `}
          value={t(status) || '-'}
        />
      ) : null}
      <FieldValue
        style={{ marginBottom: 4, fontSize: '12px' }}
        valueStyle={{ color: valueColor }}
        label="STA"
        value={displayTimeSecondFormat(sta)}
      />
      <FieldValue
        style={{ marginBottom: 4, fontSize: '12px' }}
        valueStyle={{ color: valueColor }}
        label={ata?.time || hideETA ? 'ATA' : 'ETA'}
        value={
          ata?.time
            ? displayTimeSecondFormat(ata)
            : hideETA
            ? '-'
            : displayTimeSecondFormat(eta)
        }
      />
      <FieldValue
        style={{ marginBottom: 4, fontSize: '12px' }}
        valueStyle={{ color: valueColor }}
        label="STD"
        value={displayTimeSecondFormat(std)}
      />
      <FieldValue
        style={{ marginBottom: 4, fontSize: '12px' }}
        valueStyle={{ color: valueColor }}
        label="ATD"
        value={displayTimeSecondFormat(atd)}
      />
    </MMStopsDetails>
  )
}
